import * as React from 'react';
import { Container } from 'reactstrap';
import ConsoleNavMenu from './ConsoleNavMenu';
import ConsoleSidebar from './ConsoleSidebar';
import './ConsoleLayout.css';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { bindActionCreators, Dispatch } from 'redux';
import * as ConsoleStore from '../../store/Console';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { getApplicationPermissions, getUserProfile } from '../../ApiUtils/ApiUtils';

export const UserProfileContext = React.createContext({});

type ConsoleLayoutProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
export interface UserProfile {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    permissions: userPermissions;
}
interface userPermissions {
    admin: boolean;
    root: boolean;
    applications: any[];
}
interface ConsoleState {
    userProfile?: UserProfile;
}
class ConsoleLayout extends React.PureComponent<ConsoleLayoutProps,ConsoleState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userProfile: undefined
        }
        this.getPermissions();
    }
    private  getPermissions = () => {
        var admin = false;
        var root = false;
        getApplicationPermissions().then((permissionsArray) => {
            if (permissionsArray.response?.status == 401) {
                document.cookie = "gdscp_userToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                document.cookie = "gdscp_userAuthenticated=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                // Redirect to login
                window.location.href = "/";
            } else {
                permissionsArray.applications.forEach((perm: any) => {
                    if (perm.name === "PortalAdmin@") {
                        if (perm.roles.indexOf("admin") > -1) {
                            admin = true;
                        }
                        if (perm.roles.indexOf("root") > -1) {
                            admin = false;
                            root = true;
                        }
                    }
                });
                getUserProfile().then((response: UserProfile) => {
                    this.setState({
                        userProfile: {
                            ...response,
                            permissions: { admin: admin, root: root, applications: permissionsArray }
                        }
                    });
                });
            }
            
        })
    }
    public render() {
        if (this.state.userProfile==undefined) {
            return (<React.Fragment><></></React.Fragment>)
        }
        return (
            <React.Fragment>
                <UserProfileContext.Provider value={this.state.userProfile}>
                <div className="console-wrapper">
                    <ConsoleSidebar />
                    <Container fluid className="console-content px-0">
                        <ConsoleNavMenu />                    
                        {this.props.children}
                    </Container>
                </div>
                {this.props.console?.launchState.isLaunching && (
                    <>
                        <div className="modal fade bd-example-modal-sm show" style={{ display: "block" }} role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Launching Application</h5>
                                    </div>
                                    <div className="modal-body text-center">
                                        <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />
                                        <p>Launching {this.props.console?.launchState.application}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                    )}
                </UserProfileContext.Provider>

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsoleLayout);
